import React from 'react';
import MultiSelectFilter from './MultiSelectFilter';

const TaskFilters = ({
    searchTerm,
    statusFilter,
    priorityFilter,
    approvalStatusFilter,
    overdueFilter,
    taskTypeFilter,
    viewMode,
    groupBy,
    isManager,
    activeTab,
    canCreate,
    canGroupByDepartment,
    syncingTodo,
    onSyncTodo,
    onSearchChange,
    onStatusFilterChange,
    onPriorityFilterChange,
    onApprovalStatusFilterChange,
    onOverdueFilterChange,
    onTaskTypeFilterChange,
    onViewModeChange,
    onGroupByChange,
    onCreateTask
}) => {
    const statusOptions = [
        { value: 'todo', label: 'To Do' },
        { value: 'in-progress', label: 'In Progress' },
        { value: 'review', label: 'Review' },
        { value: 'completed', label: 'Completed' }
    ];

    const priorityOptions = [
        { value: 'low', label: 'Low' },
        { value: 'medium', label: 'Medium' },
        { value: 'high', label: 'High' },
        { value: 'urgent', label: 'Urgent' }
    ];

    return (
        <div className="task-controls">
            <input 
                type="text" 
                placeholder="Search by task ID, title, name..."
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                className="search-input" 
            />
            
            {/* Status Filter - Different for Managers in Approval Tab */}
            {isManager && activeTab === 'assigned-to-me' ? (
                <select 
                    value={approvalStatusFilter || ''} 
                    onChange={(e) => onApprovalStatusFilterChange(e.target.value)} 
                    className="filter-select"
                >
                    <option value="">All Approval Status</option>
                    <option value="pending">Pending</option>
                    <option value="approved">Approved</option>
                    <option value="rejected">Rejected</option>
                </select>
            ) : (
                <MultiSelectFilter
                    label="Status"
                    options={statusOptions}
                    selectedValues={Array.isArray(statusFilter) ? statusFilter : []}
                    onChange={onStatusFilterChange}
                />
            )}
            
            <MultiSelectFilter
                label="Priority"
                options={priorityOptions}
                selectedValues={Array.isArray(priorityFilter) ? priorityFilter : []}
                onChange={onPriorityFilterChange}
            />

            {/* Task Type Filter - separate routine-generated tasks from regular ones */}
            <select
                value={taskTypeFilter || ''}
                onChange={(e) => onTaskTypeFilterChange(e.target.value)}
                className="filter-select"
            >
                <option value="">All Types</option>
                <option value="regular">📝 Regular Tasks</option>
                <option value="routine">🔁 Routine Tasks</option>
            </select>

            {/* View Mode Toggle */}
            <select 
                value={viewMode} 
                onChange={(e) => onViewModeChange(e.target.value)}
                className="filter-select view-mode-select"
            >
                <option value="list">📋 List View</option>
                <option value="grouped">📊 Grouped View</option>
            </select>
            
            {/* Group By Selector (only shown in grouped mode) */}
            {viewMode === 'grouped' && (
                <select 
                    value={groupBy} 
                    onChange={(e) => onGroupByChange(e.target.value)} 
                    className="filter-select group-by-select"
                >
                    {isManager && activeTab === 'assigned-to-me' ? (
                        <>
                            <option value="approvalStatus">Group by Approval Status</option>
                            <option value="priority">Group by Priority</option>
                            <option value="user">Group by User</option>
                            <option value="dueDate">Group by Due Date</option>
                        </>
                    ) : (
                        <>
                            <option value="status">Group by Status</option>
                            <option value="priority">Group by Priority</option>
                            <option value="user">Group by User</option>
                            <option value="role">Group by Role</option>
                            {canGroupByDepartment && (
                                <option value="department">Group by Department</option>
                            )}
                            <option value="dueDate">Group by Due Date</option>
                        </>
                    )}
                </select>
            )}
            
            {/* Outlook sync UI disabled — kept in code, gated off with false */}
            {false && canCreate && (
                <button
                    onClick={onSyncTodo}
                    disabled={syncingTodo}
                    className="btn-sync-todo"
                    title="Import your open Microsoft To Do tasks, including flagged emails"
                >
                    {syncingTodo ? 'Syncing…' : '🔄 Sync from Outlook'}
                </button>
            )}

            {canCreate && (
                <button
                    onClick={onCreateTask}
                    className="btn-create"
                >
                    + Create Task
                </button>
            )}
        </div>
    );
};

export default TaskFilters;
